import { Dispatch } from "redux";
import { Category } from "src/redux/apiTypes";
import { selectCategories } from "src/redux/categories/categoriesSelectors";
import findCategoryObject from "../../../utils/categories/findCategoryObject";
import getAllCategories from "../../categories/categoriesOperations/getAllCategories";
import { RootState } from "../../reducers";
import { endPrepareCategory, setIsUnavailableForNP, startPrepareCategory } from "../catalogueActions";
import getCategory from "./getCategory";
import getCategoryProducts from "./getCategoryProducts";

interface PrepareCategoryDataParams {
  categoryId: string,
  searchString: string,
  storeId: string;
}

const prepareCategoryData = (params: PrepareCategoryDataParams) => async (dispatch: Dispatch, getState: () => RootState) => {
  const { categoryId, searchString, storeId } = params;

  dispatch(startPrepareCategory());

  const categoriesAreEmpty = selectCategories(getState()).length === 0;

  if (categoriesAreEmpty) {
    await dispatch(getAllCategories({ storeId }));
  }

  const categories = selectCategories(getState());
  const selectedCategory: Category | null = findCategoryObject(categories, categoryId);

  const categoryNotExistsInCurrentCatalog = selectedCategory === null;

  const response = await dispatch(getCategory({
    categoryId,
    withoutDeliveryType: categoryNotExistsInCurrentCatalog,
    storeId,
  }));

  if(categoryNotExistsInCurrentCatalog && !response.error) {
    dispatch(setIsUnavailableForNP(response.payload.count > 0));
  }

  await dispatch(getCategoryProducts(storeId, searchString));
  dispatch(endPrepareCategory());
};

export default prepareCategoryData;
